import { createThunk, model, Model } from 'mst-collection';
import { types } from 'mobx-state-tree';

import { Api, FollowSuggestionStatusEnum } from '@api';
import { SuggestedUserListModel } from './SuggestedUserListModel';

export class UsersSuggestion extends Model({
  list: types.optional(SuggestedUserListModel, {}),
}) {
  save = createThunk(() => {
    return async function save(this: UsersSuggestion) {
      await Api.Profile.saveUsersSuggestionStatus({
        followStatus: FollowSuggestionStatusEnum.Done,
      });
    };
  });

  skipAndSave = createThunk(() => {
    return async function skipAndSave(this: UsersSuggestion) {
      await Api.Profile.saveUsersSuggestionStatus({
        followStatus: FollowSuggestionStatusEnum.Skipped,
      });
    };
  });

  skipAndNeverAsk = createThunk(() => {
    return async function skipAndNeverAsk(this: UsersSuggestion) {
      await Api.Profile.saveUsersSuggestionStatus({
        followStatus: FollowSuggestionStatusEnum.NeverAsk,
      });
    };
  });
}

export const UsersSuggestionModel = model(UsersSuggestion);
